import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { ManagedApplicationsEffects } from './managed-applications.effects';
import { managedApplicationsReducer, mdmManagedAppliationsFeatureKey } from './managed-applications.reducer';

export const provideManagedApplicationsStore = () => [
  provideState(mdmManagedAppliationsFeatureKey, managedApplicationsReducer),
  provideEffects([ManagedApplicationsEffects]),
];
